export enum enumGATagEventCategory {
  Isf = 'Isf',
  ES = 'EntrySummary',
  CompanyValidate = 'Company validation',
  Auth = 'Auth',
  StatusIsf = 'Status ISF',
  StatusES = 'Status ES',
  OnBoarding = 'On-Boarding',
  FreshchatWidget = 'Freshchat widget',
  EezyFreight = 'eezyFreight',
  Uship = 'uShip',
  Drip = 'Drip',
}
